import { useState } from 'react';
import axios from '../helpers/axios';
import * as Sentry from '@sentry/browser';
import { ImageCategory, ImageUploadResponse, UseFileUploadResult } from './hookTypes';

const useFileUpload = (): UseFileUploadResult => {
    const [uploading, setUploading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const uploadFile = async (file: File, category: ImageCategory): Promise<ImageUploadResponse | null> => {
        setUploading(true);
        setError(null);
        try {
            const formData = new FormData();
            formData.append('image', file);
            formData.append('category', category.toString());

            const response = await axios.post('/v2/image/upload', formData, {
                headers: { 'content-type': 'multipart/form-data' },
            });

            return response.data as ImageUploadResponse;
        } catch (err) {
            Sentry.captureException(err);
            setError('Failed to upload image. Please try again.');
            return null;
        } finally {
            setUploading(false);
        }
    };

    return { uploading, error, uploadFile };
};

export default useFileUpload;
